import React, { Component } from 'react';

class ForumGuide extends Component {
    render() {
        return (
            <div>Forum Guide</div>
        );
    };
}

export default ForumGuide;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/ForumGuide.js